export default __webpack_public_path__ + "static/media/clients.8d27d198.svg";